import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
  ORDER_STATUS_DEALER_ACCEPTED,
  ORDER_STATUS_DEALER_CANCELLED,
  ORDER_STATUS_DEALER_DECLINED,
  ORDER_STATUS_CONSUMER_CANCELLED,
  ORDER_STATUS_DEALER_DELIVERED,
} from '@chama/utils/constants/status';

const getStatusLabel = status => {
  switch (status) {
    case ORDER_STATUS_DEALER_DELIVERED:
      return <FormattedMessage id="status.dealer_delivered" defaultMessage="Delivered" />;
    case ORDER_STATUS_DEALER_ACCEPTED:
      return <FormattedMessage id="status.dealer_accepted" defaultMessage="Being delivered" />;
    case ORDER_STATUS_DEALER_DECLINED:
      return (
        <FormattedMessage id="status.declined_by_dealer" defaultMessage="Declined by dealer" />
      );
    case ORDER_STATUS_DEALER_CANCELLED:
      return (
        <FormattedMessage id="status.cancelled_by_dealer" defaultMessage="Cancelled by dealer" />
      );
    case ORDER_STATUS_CONSUMER_CANCELLED:
      return (
        <FormattedMessage
          id="status.cancelled_by_consumer"
          defaultMessage="Cancelled by consumer"
        />
      );
    default:
      return null;
  }
};

export default getStatusLabel;



// WEBPACK FOOTER //
// ../ui-components/get-order-status-label.jsx